import { configureStore } from "@reduxjs/toolkit";
import { env } from "@config";
import { analysisReducer } from "./analysis";
import { authReducer } from "./auth";
import { globalReducer } from "./global";
import { messageWizardReducer } from "./messageWizard";
import { signalsReducer } from "./signals";
import { simulatorReducer } from "./simulator";

export const store = configureStore({
  reducer: {
    analysis: analysisReducer,
    auth: authReducer,
    global: globalReducer,
    messageWizard: messageWizardReducer,
    signals: signalsReducer,
    simulator: simulatorReducer,
  },
  devTools: env.mode !== "prod",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
